module.exports = __webpack_public_path__ + "static/img/Jack_Martin_desktop.17e0c86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack_Martin_desktop.jpg
// module id = H36S
// module chunks = 0